const getters = {
    push: (state) => state.push,
    loading: (state) => state.loading,
    pushId: (state) => state.pushId,
};

export default getters;